import { useState } from "react";

import { type CapturedErrorTypes, errorStates } from "@hz/common/constants";

import { Copy } from "lucide-react";
import { useSelector } from "react-redux";

import { Box, Code, Flex, Text, VStack } from "@chakra-ui/react";

import { Button } from "@components/ui/button";

import { selectMondayState } from "@state/mondaySlice";

type ErrorInfoBoxProps = {
  type?: CapturedErrorTypes;
  errorDetails: string;
  eventId?: string;
};

const ErrorInfoBox = ({ type, errorDetails, eventId }: ErrorInfoBoxProps) => {
  const { context } = useSelector(selectMondayState);
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(errorDetails);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 3000);
  };

  return (
    <Box
      bg="gray.50"
      p={4}
      borderRadius="md"
      width="100%"
    >
      <Flex justifyContent="space-between">
        <VStack
          fontSize="sm"
          color="gray.600"
          align="start"
        >
          {eventId && (
            <Text>
              Error Code:{" "}
              <Code>
                {type ? type.toUpperCase() : errorStates.UNKNOWN}-{eventId}
              </Code>
            </Text>
          )}
          {context?.appVersion.id && (
            <Text>
              App ID: <Code>{context.appVersion.id}</Code>
            </Text>
          )}
          {context?.user.id && (
            <Text>
              User ID: <Code>{context.user.id}</Code>
            </Text>
          )}
          {context?.boardId && (
            <Text>
              Board ID: <Code>{context.boardId}</Code>
            </Text>
          )}
        </VStack>

        <Button
          size="sm"
          variant="ghost"
          onClick={handleCopy}
          color={isCopied ? "green.500" : "gray.500"}
          _hover={{
            color: "blue.500",
          }}
        >
          <Copy size={14} />
          {isCopied ? "Copied" : "Copy"}
        </Button>
      </Flex>
    </Box>
  );
};

export default ErrorInfoBox;
